<template>
  <div>
    <remCom :banner_list="banner_list" v-if="clientWidth>600" />
    <baseCom :banner_list="banner_list" v-else />
  </div>
</template>
  
<script>
import {getForm} from '@/api/banner'
import remCom from "./components/remCom.vue";
import baseCom from "./components/baseCom.vue";
import {mapState} from 'vuex'
export default {
  name: "page-box",
  computed: {
		...mapState(['clientWidth']),
	},
  components: {
    remCom,
    baseCom
  },
  data() {
    return {
      banner_list:[]
    };
  },
  created(){
    getForm({}).then((res)=>{
      this.banner_list = res.data
    })
  },
  methods: {
   
  }
};
</script>
